import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getActiveCardId = createSelector(creditCardsState, (creditCards) => creditCards?.activeCardId || null);
